export default "__VITE_ASSET__Cw9B6bos__"